import {createAsyncThunk} from '@reduxjs/toolkit';
import {addIntegrationMessages} from 'admin/integrations/add-integration';
import {integrationsApi} from 'api';
import {toastNotificationManager} from 'toast-notifications';
import {integrationDetailsMessages} from '../../details/utils/constants';
import {prefix} from './config';

export const testGoogleSitesDestinationThunk: any = createAsyncThunk(
  `${prefix} testGoogleSitesDestination`,
  async (integrationId: string, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await integrationsApi.testGoogleSiteDestinationIntegration(integrationId);
      dispatch(toastNotificationManager.createSuccessToastAction(integrationDetailsMessages.testIntegrationSuccess));
      return parsedBody;
    } catch (error) {
      const errMsg = error.messages;
      dispatch(
        toastNotificationManager.createErrorToastAction(errMsg ?? addIntegrationMessages.unknownIntegrationError)
      );
      return rejectWithValue({error});
    }
  }
);
